// This file was automatically generated from render.reqAct.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.reqAct');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqAct.contents = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection ebs-clearfix"><div class="el8VerticalTabHomeContainer req-act-hover-holder"><div class="req-act-hover-section" data-dd-privacy="allow"><div class="el8VerticalTabChoiceSection"><p class="el8AppText padh5">View Queue For:</p><div class="padh5 padv5"><select id="req-act-queue-types" class="w100"></select></div></div><div id="req-act-tabs"></div></div></div><div id="req-act-contents" class="el8InboxContainerWithVerticalTab"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqAct.tabContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="req-act-section el8ReqActSection" data-name="', soy.$$escapeHtml(opt_data.name), '"><div class="req-act-section-feed"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqAct.feedSkeleton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8HomeFeedWrap"><div class="el8Spacer el8FieldSectionOverflow ebs-form-inline"><ul class="ebs-list-inline el8InlineBlock">', (opt_data.name == 'messages') ? '<li class="el8LgSpaceButtonItem"><label class="el8FieldMedium el8SelectorTitle">Filter by:</label><div class="el8InlineBlock mh10"><select id="req-act-messages-filter" class="w100"></select></div></li>' : '');
  el8.template.render.reqAct.extraQueueButtons(opt_data, output);
  output.append((opt_data.hasLaunchButtons) ? '<li class="el8ButtonItem"><span id="req-act-' + soy.$$escapeHtml(opt_data.name) + '-launch-buttons"></span></li>' : '', '</ul><ul class="el8ButtonContainer el8InlineBlock ebs-pull-right">', (opt_data.hasSortToggle) ? '<li class="mr15 el8StandardFontSize"><span class="el8AppText">Showing: </span><a id="req-act-sort-' + soy.$$escapeHtml(opt_data.name) + '-menu-trigger" class="el8FeedActionsLink"></a></li>' : '', '<li><a id="refresh-req-act-trigger" class="el8StandardFontSize">Refresh</a></li></ul></div><ol id="req-act-', soy.$$escapeHtml(opt_data.name), '-feed-list" class="el8HomeFeed ebs-list-unstyled"></ol><div class="el8PageFeedContainer"><button type="button" id="req-act-', soy.$$escapeHtml(opt_data.name), '-more-btn" class="el8SectionButton">More</button></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqAct.messagesFilterList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<option value="', soy.$$escapeHtml(opt_data.queueType), '">All messages for ', soy.$$escapeHtml(opt_data.addresseeName), '</option>');
  if (opt_data.groups.length) {
    output.append((opt_data.userId) ? '<option value="selfdirectly-' + soy.$$escapeHtml(opt_data.userId) + '">Addressed to ' + soy.$$escapeHtml(opt_data.addresseeName) + ' directly</option>' : '');
    var gList31530 = opt_data.groups;
    var gListLen31530 = gList31530.length;
    for (var gIndex31530 = 0; gIndex31530 < gListLen31530; gIndex31530++) {
      var gData31530 = gList31530[gIndex31530];
      output.append('<option value="', soy.$$escapeHtml(gData31530.id), '">Addressed to group: ', soy.$$escapeHtml(gData31530.name), '</option>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqAct.queueList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var itemList31538 = opt_data.list;
  var itemListLen31538 = itemList31538.length;
  for (var itemIndex31538 = 0; itemIndex31538 < itemListLen31538; itemIndex31538++) {
    var itemData31538 = itemList31538[itemIndex31538];
    output.append('<option value="', soy.$$escapeHtml(itemData31538.value), '"', (itemData31538.selected) ? ' selected' : '', '>', soy.$$escapeHtml(itemData31538.name), '</option>');
  }
  if (opt_data.physicianList.length) {
    output.append('<optgroup label="Other Providers">');
    var itemList31552 = opt_data.physicianList;
    var itemListLen31552 = itemList31552.length;
    for (var itemIndex31552 = 0; itemIndex31552 < itemListLen31552; itemIndex31552++) {
      var itemData31552 = itemList31552[itemIndex31552];
      output.append('<option value="', soy.$$escapeHtml(itemData31552.value), '"', (itemData31552.selected) ? ' selected' : '', '>- ', soy.$$escapeHtml(itemData31552.name), '</option>');
    }
    output.append('</optgroup>');
  }
  if (opt_data.staffList.length) {
    output.append('<optgroup label="Other Staff">');
    var itemList31567 = opt_data.staffList;
    var itemListLen31567 = itemList31567.length;
    for (var itemIndex31567 = 0; itemIndex31567 < itemListLen31567; itemIndex31567++) {
      var itemData31567 = itemList31567[itemIndex31567];
      output.append('<option value="', soy.$$escapeHtml(itemData31567.value), '"', (itemData31567.selected) ? ' selected' : '', '>- ', soy.$$escapeHtml(itemData31567.name), '</option>');
    }
    output.append('</optgroup>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqAct.launchXButtons = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.count > 0) ? '<ul class="ebs-list-inline">' + ((opt_data.count <= 5) ? '<li class="el8ButtonItem mr15"><a class="el8StandardFontSize launch-req-act-trigger" data-name="' + soy.$$escapeHtml(opt_data.feedName) + '" data-count="' + soy.$$escapeHtml(opt_data.count) + '" data-testid="practice-home-launch-first-x-patients-button">Launch first ' + ((opt_data.count != 1) ? soy.$$escapeHtml(opt_data.count) + ' patients' : 'patient') + '</a></li>' : (opt_data.count <= 10) ? '<li class="el8ButtonItem mr15"><a class="el8StandardFontSize launch-req-act-trigger" data-name="' + soy.$$escapeHtml(opt_data.feedName) + '" data-count="5" data-testid="practice-home-launch-first-five-patients-button">Launch first 5 patients</a></li><li class="el8ButtonItem mr15"><a class="el8StandardFontSize launch-req-act-trigger" data-name="' + soy.$$escapeHtml(opt_data.feedName) + '" data-count="' + soy.$$escapeHtml(opt_data.count) + '" data-testid="practice-home-launch-first-x-patients-button">Launch first ' + ((opt_data.count != 1) ? soy.$$escapeHtml(opt_data.count) + ' patients' : 'patient') + '</a></li>' : '<li class="el8ButtonItem mr15"><a class="el8StandardFontSize launch-req-act-trigger" data-name="' + soy.$$escapeHtml(opt_data.feedName) + '" data-count="5" data-testid="practice-home-launch-first-five-patients-button">Launch first 5 patients</a></li><li class="el8ButtonItem mr15"><a class="el8StandardFontSize launch-req-act-trigger" data-name="' + soy.$$escapeHtml(opt_data.feedName) + '" data-count="10" data-testid="practice-home-launch-first-ten-patients-button">Launch first 10 patients</a></li>') + '</ul>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqAct.superTabContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="req-act-section" data-name="', soy.$$escapeHtml(opt_data.name), '"><span id="req-act-', soy.$$escapeHtml(opt_data.name), '-buttons"></span><div class="req-act-super-tab" data-name="', soy.$$escapeHtml(opt_data.name), '"></div><div class="req-act-super-tab-contents" data-name="', soy.$$escapeHtml(opt_data.name), '"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqAct.extraQueueButtons = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.name == 'patient-letters') ? '<li class="el8LgSpaceButtonItem"><a id="outstanding-passport-link" class="el8StandardFontSize mr20" target="_blank" rel="noopener">Outstanding Passport Invitations</a><span id="outstanding-passport-count" class="el8TabItemCount"></span></li>' : (opt_data.name == 'provider-letters' && el8Globals.PASSPORT_EMR) ? '<li class="el8LgSpaceButtonItem"><a class="all-patients-report-link el8StandardFontSize mr20" href="/population/?initialtab=patientlist&amp;load=1" target="_blank" rel="noopener">See All Patients</a></li>' : '');
  if (!opt_sb) return output.toString();
};
